const GET_ALL_MODULES_LIST_REQUEST = "GET_ALL_MODULES_LIST_REQUEST";
const GET_ALL_MODULES_LIST_COMPLETED = "GET_ALL_MODULES_LIST_COMPLETED";
const GET_ALL_MODULES_LIST_ERROR = "GET_ALL_MODULES_LIST_ERROR";

const GET_MODULE_CARD_REQUEST = "GET_MODULE_CARD_REQUEST";
const GET_MODULE_CARD_COMPLETED = "GET_MODULE_CARD_COMPLETED";
const GET_MODULE_CARD_ERROR = "GET_MODULE_CARD_ERROR";

const GET_MODULE_INFORMATION_REQUEST = "GET_MODULE_INFORMATION_REQUEST";
const GET_MODULE_INFORMATION_COMPLETED = "GET_MODULE_INFORMATION_COMPLETED";
const GET_MODULE_INFORMATION_ERROR = "GET_MODULE_INFORMATION_ERROR";

const ADD_NEW_MODULE_INFORMATION_REQUEST = "ADD_NEW_MODULE_INFORMATION_REQUEST";
const ADD_NEW_MODULE_INFORMATION_COMPLETED =
  "ADD_NEW_MODULE_INFORMATION_COMPLETED";
const ADD_NEW_MODULE_INFORMATION_ERROR = "ADD_NEW_MODULE_INFORMATION_ERROR";

const UPDATE_MODULE_INFORMATION_REQUEST = "UPDATE_MODULE_INFORMATION_REQUEST";
const UPDATE_MODULE_INFORMATION_COMPLETED =
  "UPDATE_MODULE_INFORMATION_COMPLETED";
const UPDATE_MODULE_INFORMATION_ERROR = "UPDATE_MODULE_INFORMATION_ERROR";

const DELETE_MODULE_REQUEST = "DELETE_MODULE_REQUEST";
const DELETE_MODULE_COMPLETED = "DELETE_MODULE_COMPLETED";
const DELETE_MODULE_ERROR = "DELETE_MODULE_ERROR";

const CHANGE_MODULE_IFORMATION = "CHANGE_MODULE_IFORMATION";
const CHANGE_MODULE_PURPOSE = "CHANGE_MODULE_PURPOSE";
const CHANGE_MODULE_RESULT_SKILL = "CHANGE_MODULE_RESULT_SKILL";
const CHANGE_MODULE_DIGITAL_USAGE = "CHANGE_MODULE_DIGITAL_USAGE";
const CHANGE_MODULE_SCHEDULE = "CHANGE_MODULE_SCHEDULE";
const CHANGE_MODULE_ESTIMATE = "CHANGE_MODULE_ESTIMATE";

const GET_EDUCATION_FORM_REQUEST = "GET_EDUCATION_FORM_REQUEST";
const GET_EDUCATION_FORM_COMPLETED = "GET_EDUCATION_FORM_COMPLETED";
const GET_EDUCATION_FORM_ERROR = "GET_EDUCATION_FORM_ERROR";

const GET_TRIAL_FORM_REQUEST = "GET_TRIAL_FORM_REQUEST";
const GET_TRIAL_FORM_COMPLETED = "GET_TRIAL_FORM_COMPLETED";
const GET_TRIAL_FORM_ERROR = "GET_TRIAL_FORM_ERROR";

const GET_MODULE_PURPOSE_REQUEST = "GET_MODULE_PURPOSE_REQUEST";
const GET_MODULE_PURPOSE_COMPLETED = "GET_MODULE_PURPOSE_COMPLETED";
const GET_MODULE_PURPOSE_ERROR = "GET_MODULE_PURPOSE_ERROR";

const GET_MODULE_RESULT_SKILL_REQUEST = "GET_MODULE_RESULT_SKILL_REQUEST";
const GET_MODULE_RESULT_SKILL_COMPLETED = "GET_MODULE_RESULT_SKILL_COMPLETED";
const GET_MODULE_RESULT_SKILL_ERROR = "GET_MODULE_RESULT_SKILL_ERROR";

const GET_MODULE_DIGITAL_USAGE_REQUEST = "GET_MODULE_DIGITAL_USAGE_REQUEST";
const GET_MODULE_DIGITAL_USAGE_COMPLETED = "GET_MODULE_DIGITAL_USAGE_COMPLETED";
const GET_MODULE_DIGITAL_USAGE_ERROR = "GET_MODULE_DIGITAL_USAGE_ERROR";

const GET_MODULE_ABILITY_REQUEST = "GET_MODULE_ABILITY_REQUEST";
const GET_MODULE_ABILITY_COMPLETED = "GET_MODULE_ABILITY_COMPLETED";
const GET_MODULE_ABILITY_ERROR = "GET_MODULE_ABILITY_ERROR";

const ADD_NEW_MODULE_ABILITY_REQUEST = "ADD_NEW_MODULE_ABILITY_REQUEST";
const ADD_NEW_MODULE_ABILITY_COMPLETED = "ADD_NEW_MODULE_ABILITY_COMPLETED";
const ADD_NEW_MODULE_ABILITY_ERROR = "ADD_NEW_MODULE_ABILITY_ERROR";

const UPDATE_MODULE_ABILITY_REQUEST = "UPDATE_MODULE_ABILITY_REQUEST";
const UPDATE_MODULE_ABILITY_COMPLETED = "UPDATE_MODULE_ABILITY_COMPLETED";
const UPDATE_MODULE_ABILITY_ERROR = "UPDATE_MODULE_ABILITY_ERROR";

const DELETE_MODULE_ABILITY_REQUEST = "DELETE_MODULE_ABILITY_REQUEST";
const DELETE_MODULE_ABILITY_COMPLETED = "DELETE_MODULE_ABILITY_COMPLETED";
const DELETE_MODULE_ABILITY_ERROR = "DELETE_MODULE_ABILITY_ERROR";

const ADD_MODULE_CARD_LOGO_REQUEST = "ADD_MODULE_CARD_LOGO_REQUEST";
const ADD_MODULE_CARD_LOGO_COMPLETED = "ADD_MODULE_CARD_LOGO_COMPLETED";
const ADD_MODULE_CARD_LOGO_ERROR = "ADD_MODULE_CARD_LOGO_ERROR";

const DELETE_MODULE_CARD_LOGO_REQUEST = "DELETE_MODULE_CARD_LOGO_REQUEST";
const DELETE_MODULE_CARD_LOGO_COMPLETED = "DELETE_MODULE_CARD_LOGO_COMPLETED";
const DELETE_MODULE_CARD_LOGO_ERROR = "DELETE_MODULE_CARD_LOGO_ERROR";

const ADD_MODULE_PROGRAM_REQUEST = "ADD_MODULE_PROGRAM_REQUEST";
const ADD_MODULE_PROGRAM_COMPLETED = "ADD_MODULE_PROGRAM_COMPLETED";
const ADD_MODULE_PROGRAM_ERROR = "ADD_MODULE_PROGRAM_ERROR";

const DELETE_MODULE_PROGRAM_REQUEST = "DELETE_MODULE_PROGRAM_REQUEST";
const DELETE_MODULE_PROGRAM_COMPLETED = "DELETE_MODULE_PROGRAM_COMPLETED";
const DELETE_MODULE_PROGRAM_ERROR = "DELETE_MODULE_PROGRAM_ERROR";

const GET_ALL_MODULE_VOLUME_REQUEST = "GET_ALL_MODULE_VOLUME_REQUEST";
const GET_ALL_MODULE_VOLUME_COMPLETED = "GET_ALL_MODULE_VOLUME_COMPLETED";
const GET_ALL_MODULE_VOLUME_ERROR = "GET_ALL_MODULE_VOLUME_ERROR";

const ADD_MODULE_VOLUME_REQUEST = "ADD_MODULE_VOLUME_REQUEST";
const ADD_MODULE_VOLUME_COMPLETED = "ADD_MODULE_VOLUME_COMPLETED";
const ADD_MODULE_VOLUME_ERROR = "ADD_MODULE_VOLUME_ERROR";

const UPDATE_MODULE_VOLUME_REQUEST = "UPDATE_MODULE_VOLUME_REQUEST";
const UPDATE_MODULE_VOLUME_COMPLETED = "UPDATE_MODULE_VOLUME_COMPLETED";
const UPDATE_MODULE_VOLUME_ERROR = "UPDATE_MODULE_VOLUME_ERROR";

const DELETE_MODULE_VOLUME_REQUEST = "DELETE_MODULE_VOLUME_REQUEST";
const DELETE_MODULE_VOLUME_COMPLETED = "DELETE_MODULE_VOLUME_COMPLETED";
const DELETE_MODULE_VOLUME_ERROR = "DELETE_MODULE_VOLUME_ERROR";

const GET_ALL_MODULE_THEME_VOLUME_REQUEST =
  "GET_ALL_MODULE_THEME_VOLUME_REQUEST";
const GET_ALL_MODULE_THEME_VOLUME_COMPLETED =
  "GET_ALL_MODULE_THEME_VOLUME_COMPLETED";
const GET_ALL_MODULE_THEME_VOLUME_ERROR = "GET_ALL_MODULE_THEME_VOLUME_ERROR";

const GET_ALL_MODULE_ABILITY_THEME_REQUEST =
  "GET_ALL_MODULE_ABILITY_THEME_REQUEST";
const GET_ALL_MODULE_ABILITY_THEME_COMPLETED =
  "GET_ALL_MODULE_ABILITY_THEME_COMPLETED";
const GET_ALL_MODULE_ABILITY_THEME_ERROR = "GET_ALL_MODULE_ABILITY_THEME_ERROR";

const ADD_MODULE_THEME_VOLUME_REQUEST = "ADD_MODULE_THEME_VOLUME_REQUEST";
const ADD_MODULE_THEME_VOLUME_COMPLETED = "ADD_MODULE_THEME_VOLUME_COMPLETED";
const ADD_MODULE_THEME_VOLUME_ERROR = "ADD_MODULE_THEME_VOLUME_ERROR";

const UPDATE_MODULE_THEME_VOLUME_REQUEST = "UPDATE_MODULE_THEME_VOLUME_REQUEST";
const UPDATE_MODULE_THEME_VOLUME_COMPLETED =
  "UPDATE_MODULE_THEME_VOLUME_COMPLETED";
const UPDATE_MODULE_THEME_VOLUME_ERROR = "UPDATE_MODULE_THEME_VOLUME_ERROR";

const DELETE_MODULE_THEME_VOLUME_REQUEST = "DELETE_MODULE_THEME_VOLUME_REQUEST";
const DELETE_MODULE_THEME_VOLUME_COMPLETED =
  "DELETE_MODULE_THEME_VOLUME_COMPLETED";
const DELETE_MODULE_THEME_VOLUME_ERROR = "DELETE_MODULE_THEME_VOLUME_ERROR";

const GET_ALL_MODULE_LESSON_REQUEST = "GET_ALL_MODULE_LESSON_REQUEST";
const GET_ALL_MODULE_LESSON_COMPLETED = "GET_ALL_MODULE_LESSON_COMPLETED";
const GET_ALL_MODULE_LESSON_ERROR = "GET_ALL_MODULE_LESSON_ERROR";

const GET_ALL_MODULE_LESSON_THEME_REQUEST =
  " GET_ALL_MODULE_LESSON_THEME_REQUEST";
const GET_ALL_MODULE_LESSON_THEME_COMPLETED =
  " GET_ALL_MODULE_LESSON_THEME_COMPLETED";
const GET_ALL_MODULE_LESSON_THEME_ERROR = " GET_ALL_MODULE_LESSON_THEME_ERROR";

const ADD_MODULE_LESSON_REQUEST = "ADD_MODULE_LESSON_REQUEST";
const ADD_MODULE_LESSON_COMPLETED = "ADD_MODULE_LESSON_COMPLETED";
const ADD_MODULE_LESSON_ERROR = "ADD_MODULE_LESSON_ERROR";

const UPDATE_MODULE_LESSON_REQUEST = "UPDATE_MODULE_LESSON_REQUEST";
const UPDATE_MODULE_LESSON_COMPLETED = "UPDATE_MODULE_LESSON_COMPLETED";
const UPDATE_MODULE_LESSON_ERROR = "UPDATE_MODULE_LESSON_ERROR";

const DELETE_MODULE_LESSON_REQUEST = "DELETE_MODULE_LESSON_REQUEST";
const DELETE_MODULE_LESSON_COMPLETED = "DELETE_MODULE_LESSON_COMPLETED";
const DELETE_MODULE_LESSON_ERROR = "DELETE_MODULE_LESSON_ERROR";

const GET_ALL_LESSON_TYPE_REQUEST = "GET_ALL_LESSON_TYPE_REQUEST";
const GET_ALL_LESSON_TYPE_COMPLETED = "GET_ALL_LESSON_TYPE_COMPLETED";
const GET_ALL_LESSON_TYPE_ERROR = "GET_ALL_LESSON_TYPE_ERROR";

const GET_ALL_RESOURCE_LIST_REQUEST = "GET_ALL_RESOURCE_LIST_REQUEST";
const GET_ALL_RESOURCE_LIST_COMPLETED = "GET_ALL_RESOURCE_LIST_COMPLETED";
const GET_ALL_RESOURCE_LIST_ERROR = "GET_ALL_RESOURCE_LIST_ERROR";

const GET_LESSON_RESOURCE_LIST_REQUEST = "GET_LESSON_RESOURCE_LIST_REQUEST";
const GET_LESSON_RESOURCE_LIST_COMPLETED = "GET_LESSON_RESOURCE_LIST_COMPLETED";
const GET_LESSON_RESOURCE_LIST_ERROR = "GET_LESSON_RESOURCE_LIST_ERROR";

const GET_ALL_ROOM_TYPES_LIST_REQUEST = "GET_ALL_ROOM_TYPES_LIST_REQUEST";
const GET_ALL_ROOM_TYPES_LIST_COMPLETED = "GET_ALL_ROOM_TYPES_LIST_COMPLETED";
const GET_ALL_ROOM_TYPES_LIST_ERROR = "GET_ALL_ROOM_TYPES_LIST_ERROR";

const GET_ALL_MODULE_ROOM_LIST_REQUEST = "GET_ALL_MODULE_ROOM_LIST_REQUEST";
const GET_ALL_MODULE_ROOM_LIST_COMPLETED = "GET_ALL_MODULE_ROOM_LIST_COMPLETED";
const GET_ALL_MODULE_ROOM_LIST_ERROR = "GET_ALL_MODULE_ROOM_LIST_ERROR";

const ADD_MODULE_ROOM_LIST_REQUEST = "ADD_MODULE_ROOM_LIST_REQUEST";
const ADD_MODULE_ROOM_LIST_COMPLETED = "ADD_MODULE_ROOM_LIST_COMPLETED";
const ADD_MODULE_ROOM_LIST_ERROR = "ADD_MODULE_ROOM_LIST_ERROR";

const UPDATE_MODULE_ROOM_REQUEST = "UPDATE_MODULE_ROOM_REQUEST";
const UPDATE_MODULE_ROOM_COMPLETED = "UPDATE_MODULE_ROOM_COMPLETED";
const UPDATE_MODULE_ROOM_ERROR = "UPDATE_MODULE_ROOM_ERROR";

const DELETE_MODULE_ROOM_REQUEST = "DELETE_MODULE_ROOM_REQUEST";
const DELETE_MODULE_ROOM_COMPLETED = "DELETE_MODULE_ROOM_COMPLETED";
const DELETE_MODULE_ROOM_ERROR = "DELETE_MODULE_ROOM_ERROR";

const GET_ALL_MODULE_RESOURCE_LIST_REQUEST =
  "GET_ALL_MODULE_RESOURCE_LIST_REQUEST";
const GET_ALL_MODULE_RESOURCE_LIST_COMPLETED =
  "GET_ALL_MODULE_RESOURCE_LIST_COMPLETED";
const GET_ALL_MODULE_RESOURCE_LIST_ERROR = "GET_ALL_MODULE_RESOURCE_LIST_ERROR";

const ADD_MODULE_RESOURCE_REQUEST = "ADD_MODULE_RESOURCE_REQUEST";
const ADD_MODULE_RESOURCE_COMPLETED = "ADD_MODULE_RESOURCE_COMPLETED";
const ADD_MODULE_RESOURCE_ERROR = "ADD_MODULE_RESOURCE_ERROR";

const UPDATE_MODULE_RESOURCE_REQUEST = "UPDATE_MODULE_RESOURCE_REQUEST";
const UPDATE_MODULE_RESOURCE_COMPLETED = "UPDATE_MODULE_RESOURCE_COMPLETED";
const UPDATE_MODULE_RESOURCE_ERROR = "UPDATE_MODULE_RESOURCE_ERROR";

const DELETE_MODULE_RESOURCE_REQUEST = "DELETE_MODULE_RESOURCE_REQUEST";
const DELETE_MODULE_RESOURCE_COMPLETED = "DELETE_MODULE_RESOURCE_COMPLETED";
const DELETE_MODULE_RESOURCE_ERROR = "DELETE_MODULE_RESOURCE_ERROR";

const GET_ALL_RESOURCE_TYPE_LIST_REQUEST =
  "GET_ALL_RESOURCE_TYPES_LIST_REQUEST";
const GET_ALL_RESOURCE_TYPE_LIST_COMPLETED =
  "GET_ALL_RESOURCE_TYPES_LIST_COMPLETED";
const GET_ALL_RESOURCE_TYPE_LIST_ERROR = "GET_ALL_RESOURCE_TYPES_LIST_ERROR";

const GET_ALL_MODULE_REFERENCE_LIST_REQUEST =
  "GET_ALL_MODULE_REFERENCE_LIST_REQUEST";
const GET_ALL_MODULE_REFERENCE_LIST_COMPLETED =
  "GET_ALL_MODULE_REFERENCE_LIST_COMPLETED";
const GET_ALL_MODULE_REFERENCE_LIST_ERROR =
  "GET_ALL_MODULE_REFERENCE_LIST_ERROR";

const ADD_MODULE_REFERENCE_REQUEST = "ADD_MODULE_REFERENCE_REQUEST";
const ADD_MODULE_REFERENCE_COMPLETED = "ADD_MODULE_REFERENCE_COMPLETED";
const ADD_MODULE_REFERENCE_ERROR = "ADD_MODULE_REFERENCE_ERROR";

const UPDATE_MODULE_REFERENCE_REQUEST = "UPDATE_MODULE_REFERENCE_REQUEST";
const UPDATE_MODULE_REFERENCE_COMPLETED = "UPDATE_MODULE_REFERENCE_COMPLETED";
const UPDATE_MODULE_REFERENCE_ERROR = "UPDATE_MODULE_REFERENCE_ERROR";

const DELETE_MODULE_REFERENCE_REQUEST = "DELETE_MODULE_REFERENCE_REQUEST";
const DELETE_MODULE_REFERENCE_COMPLETED = "DELETE_MODULE_REFERENCE_COMPLETED";
const DELETE_MODULE_REFERENCE_ERROR = "DELETE_MODULE_REFERENCE_ERROR";

const GET_ALL_MODULE_SITE_LIST_REQUEST = "GET_ALL_MODULE_SITE_LIST_REQUEST";
const GET_ALL_MODULE_SITE_LIST_COMPLETED = "GET_ALL_MODULE_SITE_LIST_COMPLETED";
const GET_ALL_MODULE_SITE_LIST_ERROR = "GET_ALL_MODULE_SITE_LIST_ERROR";

const ADD_MODULE_SITE_REQUEST = "ADD_MODULE_SITE_REQUEST";
const ADD_MODULE_SITE_COMPLETED = "ADD_MODULE_SITE_COMPLETED";
const ADD_MODULE_SITE_ERROR = "ADD_MODULE_SITE_ERROR";

const UPDATE_MODULE_SITE_REQUEST = "UPDATE_MODULE_SITE_REQUEST";
const UPDATE_MODULE_SITE_COMPLETED = "UPDATE_MODULE_SITE_COMPLETED";
const UPDATE_MODULE_SITE_ERROR = "UPDATE_MODULE_SITE_ERROR";

const DELETE_MODULE_SITE_REQUEST = "DELETE_MODULE_SITE_REQUEST";
const DELETE_MODULE_SITE_COMPLETED = "DELETE_MODULE_SITE_COMPLETED";
const DELETE_MODULE_SITE_ERROR = "DELETE_MODULE_SITE_ERROR";

const GET_MODULE_SCHEDULE_REQUEST = "GET_MODULE_SCHEDULE_REQUEST";
const GET_MODULE_SCHEDULE_COMPLETED = "GET_MODULE_SCHEDULE_COMPLETED";
const GET_MODULE_SCHEDULE_ERROR = "GET_MODULE_SCHEDULE_ERROR";

const GET_MODULE_ESTIMATE_REQUEST = "GET_MODULE_ESTIMATE_REQUEST";
const GET_MODULE_ESTIMATE_COMPLETED = "GET_MODULE_ESTIMATE_COMPLETED";
const GET_MODULE_ESTIMATE_ERROR = "GET_MODULE_ESTIMATE_ERROR";

const GET_ALL_MODULE_CRITERION_LIST_REQUEST =
  "GET_ALL_MODULE_CRITERION_LIST_REQUEST,";
const GET_ALL_MODULE_CRITERION_LIST_COMPLETED =
  "GET_ALL_MODULE_CRITERION_LIST_COMPLETED,";
const GET_ALL_MODULE_CRITERION_LIST_ERROR =
  "GET_ALL_MODULE_CRITERION_LIST_ERROR,";

const ADD_MODULE_CRITERION_REQUEST = "ADD_MODULE_CRITERION_REQUEST,";
const ADD_MODULE_CRITERION_COMPLETED = "ADD_MODULE_CRITERION_COMPLETED,";
const ADD_MODULE_CRITERION_ERROR = "ADD_MODULE_CRITERION_ERROR,";

const UPDATE_MODULE_CRITERION_REQUEST = "UPDATE_MODULE_CRITERION_REQUEST,";
const UPDATE_MODULE_CRITERION_COMPLETED = "UPDATE_MODULE_CRITERION_COMPLETED,";
const UPDATE_MODULE_CRITERION_ERROR = "UPDATE_MODULE_CRITERION_ERROR,";

const DELETE_MODULE_CRITERION_REQUEST = "DELETE_MODULE_CRITERION_REQUEST,";
const DELETE_MODULE_CRITERION_COMPLETED = "DELETE_MODULE_CRITERION_COMPLETED,";
const DELETE_MODULE_CRITERION_ERROR = "DELETE_MODULE_CRITERION_ERROR,";

const GET_ALL_MODULE_COMPILERS_REQUEST = "GET_ALL_MODULE_COMPILERS_REQUEST";
const GET_ALL_MODULE_COMPILERS_COMPLETED = "GET_ALL_MODULE_COMPILERS_COMPLETED";
const GET_ALL_MODULE_COMPILERS_ERROR = "GET_ALL_MODULE_COMPILERS_ERROR";

const MODULE_COMPILERS_REQUEST = "MODULE_COMPILERS_REQUEST";
const MODULE_COMPILERS_COMPLETED = "MODULE_COMPILERS_COMPLETED";
const MODULE_COMPILERS_ERROR = "MODULE_COMPILERS_ERROR";

const GET_ORGANIZATION_STAFF_REQUEST = "GET_ORGANIZATION_STAFF_REQUEST";
const GET_ORGANIZATION_STAFF_COMPLETED = "GET_ORGANIZATION_STAFF_COMPLETED";
const GET_ORGANIZATION_STAFF_ERROR = "GET_ORGANIZATION_STAFF_ERROR";

export default {
  CHANGE_MODULE_IFORMATION,
  CHANGE_MODULE_PURPOSE,
  CHANGE_MODULE_RESULT_SKILL,
  CHANGE_MODULE_DIGITAL_USAGE,
  CHANGE_MODULE_SCHEDULE,
  CHANGE_MODULE_ESTIMATE,

  GET_ALL_MODULES_LIST_REQUEST,
  GET_ALL_MODULES_LIST_COMPLETED,
  GET_ALL_MODULES_LIST_ERROR,

  GET_MODULE_CARD_REQUEST,
  GET_MODULE_CARD_COMPLETED,
  GET_MODULE_CARD_ERROR,

  ADD_NEW_MODULE_INFORMATION_REQUEST,
  ADD_NEW_MODULE_INFORMATION_COMPLETED,
  ADD_NEW_MODULE_INFORMATION_ERROR,

  GET_MODULE_INFORMATION_REQUEST,
  GET_MODULE_INFORMATION_COMPLETED,
  GET_MODULE_INFORMATION_ERROR,

  UPDATE_MODULE_INFORMATION_REQUEST,
  UPDATE_MODULE_INFORMATION_COMPLETED,
  UPDATE_MODULE_INFORMATION_ERROR,

  DELETE_MODULE_REQUEST,
  DELETE_MODULE_COMPLETED,
  DELETE_MODULE_ERROR,

  GET_EDUCATION_FORM_REQUEST,
  GET_EDUCATION_FORM_COMPLETED,
  GET_EDUCATION_FORM_ERROR,

  GET_TRIAL_FORM_REQUEST,
  GET_TRIAL_FORM_COMPLETED,
  GET_TRIAL_FORM_ERROR,

  GET_MODULE_PURPOSE_REQUEST,
  GET_MODULE_PURPOSE_COMPLETED,
  GET_MODULE_PURPOSE_ERROR,

  GET_MODULE_RESULT_SKILL_REQUEST,
  GET_MODULE_RESULT_SKILL_COMPLETED,
  GET_MODULE_RESULT_SKILL_ERROR,

  GET_MODULE_ABILITY_REQUEST,
  GET_MODULE_ABILITY_COMPLETED,
  GET_MODULE_ABILITY_ERROR,

  ADD_NEW_MODULE_ABILITY_REQUEST,
  ADD_NEW_MODULE_ABILITY_COMPLETED,
  ADD_NEW_MODULE_ABILITY_ERROR,

  UPDATE_MODULE_ABILITY_REQUEST,
  UPDATE_MODULE_ABILITY_COMPLETED,
  UPDATE_MODULE_ABILITY_ERROR,

  DELETE_MODULE_ABILITY_REQUEST,
  DELETE_MODULE_ABILITY_COMPLETED,
  DELETE_MODULE_ABILITY_ERROR,

  GET_MODULE_DIGITAL_USAGE_REQUEST,
  GET_MODULE_DIGITAL_USAGE_COMPLETED,
  GET_MODULE_DIGITAL_USAGE_ERROR,

  ADD_MODULE_CARD_LOGO_REQUEST,
  ADD_MODULE_CARD_LOGO_COMPLETED,
  ADD_MODULE_CARD_LOGO_ERROR,

  DELETE_MODULE_CARD_LOGO_REQUEST,
  DELETE_MODULE_CARD_LOGO_COMPLETED,
  DELETE_MODULE_CARD_LOGO_ERROR,

  ADD_MODULE_PROGRAM_REQUEST,
  ADD_MODULE_PROGRAM_COMPLETED,
  ADD_MODULE_PROGRAM_ERROR,

  DELETE_MODULE_PROGRAM_REQUEST,
  DELETE_MODULE_PROGRAM_COMPLETED,
  DELETE_MODULE_PROGRAM_ERROR,

  GET_ALL_MODULE_VOLUME_REQUEST,
  GET_ALL_MODULE_VOLUME_COMPLETED,
  GET_ALL_MODULE_VOLUME_ERROR,

  ADD_MODULE_VOLUME_REQUEST,
  ADD_MODULE_VOLUME_COMPLETED,
  ADD_MODULE_VOLUME_ERROR,

  UPDATE_MODULE_VOLUME_REQUEST,
  UPDATE_MODULE_VOLUME_COMPLETED,
  UPDATE_MODULE_VOLUME_ERROR,

  DELETE_MODULE_VOLUME_REQUEST,
  DELETE_MODULE_VOLUME_COMPLETED,
  DELETE_MODULE_VOLUME_ERROR,

  GET_ALL_MODULE_THEME_VOLUME_REQUEST,
  GET_ALL_MODULE_THEME_VOLUME_COMPLETED,
  GET_ALL_MODULE_THEME_VOLUME_ERROR,

  GET_ALL_MODULE_ABILITY_THEME_REQUEST,
  GET_ALL_MODULE_ABILITY_THEME_COMPLETED,
  GET_ALL_MODULE_ABILITY_THEME_ERROR,

  ADD_MODULE_THEME_VOLUME_REQUEST,
  ADD_MODULE_THEME_VOLUME_COMPLETED,
  ADD_MODULE_THEME_VOLUME_ERROR,

  UPDATE_MODULE_THEME_VOLUME_REQUEST,
  UPDATE_MODULE_THEME_VOLUME_COMPLETED,
  UPDATE_MODULE_THEME_VOLUME_ERROR,

  DELETE_MODULE_THEME_VOLUME_REQUEST,
  DELETE_MODULE_THEME_VOLUME_COMPLETED,
  DELETE_MODULE_THEME_VOLUME_ERROR,

  GET_ALL_MODULE_LESSON_REQUEST,
  GET_ALL_MODULE_LESSON_COMPLETED,
  GET_ALL_MODULE_LESSON_ERROR,

  GET_ALL_MODULE_LESSON_THEME_REQUEST,
  GET_ALL_MODULE_LESSON_THEME_COMPLETED,
  GET_ALL_MODULE_LESSON_THEME_ERROR,

  ADD_MODULE_LESSON_REQUEST,
  ADD_MODULE_LESSON_COMPLETED,
  ADD_MODULE_LESSON_ERROR,

  UPDATE_MODULE_LESSON_REQUEST,
  UPDATE_MODULE_LESSON_COMPLETED,
  UPDATE_MODULE_LESSON_ERROR,

  DELETE_MODULE_LESSON_REQUEST,
  DELETE_MODULE_LESSON_COMPLETED,
  DELETE_MODULE_LESSON_ERROR,

  GET_ALL_LESSON_TYPE_REQUEST,
  GET_ALL_LESSON_TYPE_COMPLETED,
  GET_ALL_LESSON_TYPE_ERROR,

  GET_ALL_RESOURCE_LIST_REQUEST,
  GET_ALL_RESOURCE_LIST_COMPLETED,
  GET_ALL_RESOURCE_LIST_ERROR,

  GET_LESSON_RESOURCE_LIST_REQUEST,
  GET_LESSON_RESOURCE_LIST_COMPLETED,
  GET_LESSON_RESOURCE_LIST_ERROR,

  GET_ALL_ROOM_TYPES_LIST_REQUEST,
  GET_ALL_ROOM_TYPES_LIST_COMPLETED,
  GET_ALL_ROOM_TYPES_LIST_ERROR,

  GET_ALL_MODULE_ROOM_LIST_REQUEST,
  GET_ALL_MODULE_ROOM_LIST_COMPLETED,
  GET_ALL_MODULE_ROOM_LIST_ERROR,

  ADD_MODULE_ROOM_LIST_REQUEST,
  ADD_MODULE_ROOM_LIST_COMPLETED,
  ADD_MODULE_ROOM_LIST_ERROR,

  UPDATE_MODULE_ROOM_REQUEST,
  UPDATE_MODULE_ROOM_COMPLETED,
  UPDATE_MODULE_ROOM_ERROR,

  DELETE_MODULE_ROOM_REQUEST,
  DELETE_MODULE_ROOM_COMPLETED,
  DELETE_MODULE_ROOM_ERROR,

  GET_ALL_MODULE_RESOURCE_LIST_REQUEST,
  GET_ALL_MODULE_RESOURCE_LIST_COMPLETED,
  GET_ALL_MODULE_RESOURCE_LIST_ERROR,

  ADD_MODULE_RESOURCE_REQUEST,
  ADD_MODULE_RESOURCE_COMPLETED,
  ADD_MODULE_RESOURCE_ERROR,

  UPDATE_MODULE_RESOURCE_REQUEST,
  UPDATE_MODULE_RESOURCE_COMPLETED,
  UPDATE_MODULE_RESOURCE_ERROR,

  DELETE_MODULE_RESOURCE_REQUEST,
  DELETE_MODULE_RESOURCE_COMPLETED,
  DELETE_MODULE_RESOURCE_ERROR,

  GET_ALL_RESOURCE_TYPE_LIST_REQUEST,
  GET_ALL_RESOURCE_TYPE_LIST_COMPLETED,
  GET_ALL_RESOURCE_TYPE_LIST_ERROR,

  GET_ALL_MODULE_REFERENCE_LIST_REQUEST,
  GET_ALL_MODULE_REFERENCE_LIST_COMPLETED,
  GET_ALL_MODULE_REFERENCE_LIST_ERROR,

  ADD_MODULE_REFERENCE_REQUEST,
  ADD_MODULE_REFERENCE_COMPLETED,
  ADD_MODULE_REFERENCE_ERROR,

  UPDATE_MODULE_REFERENCE_REQUEST,
  UPDATE_MODULE_REFERENCE_COMPLETED,
  UPDATE_MODULE_REFERENCE_ERROR,

  DELETE_MODULE_REFERENCE_REQUEST,
  DELETE_MODULE_REFERENCE_COMPLETED,
  DELETE_MODULE_REFERENCE_ERROR,

  GET_ALL_MODULE_SITE_LIST_REQUEST,
  GET_ALL_MODULE_SITE_LIST_COMPLETED,
  GET_ALL_MODULE_SITE_LIST_ERROR,

  ADD_MODULE_SITE_REQUEST,
  ADD_MODULE_SITE_COMPLETED,
  ADD_MODULE_SITE_ERROR,

  UPDATE_MODULE_SITE_REQUEST,
  UPDATE_MODULE_SITE_COMPLETED,
  UPDATE_MODULE_SITE_ERROR,

  DELETE_MODULE_SITE_REQUEST,
  DELETE_MODULE_SITE_COMPLETED,
  DELETE_MODULE_SITE_ERROR,

  GET_MODULE_SCHEDULE_REQUEST,
  GET_MODULE_SCHEDULE_COMPLETED,
  GET_MODULE_SCHEDULE_ERROR,

  GET_MODULE_ESTIMATE_REQUEST,
  GET_MODULE_ESTIMATE_COMPLETED,
  GET_MODULE_ESTIMATE_ERROR,

  GET_ALL_MODULE_CRITERION_LIST_REQUEST,
  GET_ALL_MODULE_CRITERION_LIST_COMPLETED,
  GET_ALL_MODULE_CRITERION_LIST_ERROR,

  ADD_MODULE_CRITERION_REQUEST,
  ADD_MODULE_CRITERION_COMPLETED,
  ADD_MODULE_CRITERION_ERROR,

  UPDATE_MODULE_CRITERION_REQUEST,
  UPDATE_MODULE_CRITERION_COMPLETED,
  UPDATE_MODULE_CRITERION_ERROR,

  DELETE_MODULE_CRITERION_REQUEST,
  DELETE_MODULE_CRITERION_COMPLETED,
  DELETE_MODULE_CRITERION_ERROR,

  GET_ALL_MODULE_COMPILERS_REQUEST,
  GET_ALL_MODULE_COMPILERS_COMPLETED,
  GET_ALL_MODULE_COMPILERS_ERROR,

  MODULE_COMPILERS_REQUEST,
  MODULE_COMPILERS_COMPLETED,
  MODULE_COMPILERS_ERROR,

  GET_ORGANIZATION_STAFF_REQUEST,
  GET_ORGANIZATION_STAFF_COMPLETED,
  GET_ORGANIZATION_STAFF_ERROR
};
